import { NavigationLinks } from '@features';
import { AppShell, ScrollArea } from '@mantine/core';

export const SideBar: React.FC = () => {
  return (
    <AppShell.Section bg="layout.1" h="100%" component={ScrollArea}>
      <NavigationLinks />
    </AppShell.Section>
  );
};
